import { useEffect, useRef } from "react";
import Highcharts from "highcharts";

const BaseChart = ({ options, className, style }) => {
  const containerRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    chartRef.current = Highcharts.chart(containerRef.current, {
      credits: { enabled: false },
      accessibility: { enabled: false },
      ...options,
    });
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (chartRef.current && options) {
      chartRef.current.update(
        { credits: { enabled: false }, accessibility: { enabled: false }, ...options },
        true,
        true,
      );
    }
  }, [options]);

  return <div ref={containerRef} className={className} style={style} />;
};

export default BaseChart;
